// extracted by mini-css-extract-plugin
export default {"content":"EditProfilePage_content__UMHcQ","tabs":"EditProfilePage_tabs__TIKKn"};